import { FaDollarSign, FaMapPin } from 'react-icons/fa6';
import { GiReceiveMoney } from 'react-icons/gi';
import {
    LuBuilding2,
    LuCalendarDays,
    LuCheck,
    LuChevronDown,
    LuCircleCheck,
    LuCirclePause,
    LuClipboardList,
    LuClock,
    LuGripVertical,
    LuPencil,
    LuSearch,
    LuSquareCheckBig,
    LuTrash2,
    LuTriangleAlert,
    LuUserPlus,
    LuUsers,
    LuVideo,
    LuX,
} from 'react-icons/lu';
import { MdOutlineAssignmentInd } from 'react-icons/md';

// Claro
export const AssigneeIcon = MdOutlineAssignmentInd;
export const HouseholdIcon = LuUsers;
export const ProspectIcon = LuUserPlus;

// Common
export const Building2Icon = LuBuilding2;
export const CalendarIcon = LuCalendarDays;
export const CheckCircleIcon = LuCircleCheck;
export const CheckIcon = LuCheck;
export const CheckSquareIcon = LuSquareCheckBig;
export const ChevronDownIcon = LuChevronDown;
export const ClipboardListIcon = LuClipboardList;
export const ClockIcon = LuClock;
export const DollarIcon = FaDollarSign;
export const ExclamationTriangleIcon = LuTriangleAlert;
export const GrabberIcon = LuGripVertical;
export const MapPinIcon = FaMapPin;
export const PauseCircleIcon = LuCirclePause;
export const PencilIcon = LuPencil;
export const ReceiveMoney = GiReceiveMoney;
export const SearchIcon = LuSearch;
export const TrashIcon = LuTrash2;
export const UsersIcon = LuUsers;
export const VideoIcon = LuVideo;
export const XIcon = LuX;
